import { filter, isEmpty, map, pick } from 'lodash';
import React, { useCallback, useMemo } from 'react';

import { FiltersChips, FiltersDropdown } from 'components';
import { FilterDefinitionType } from 'enums';
import { useQueryFilters } from 'hooks';
import { DateFilters, FilterDefinition } from 'types';
import { filtersUtils } from 'utils';

type Props = {
  filtersDefinitions: FilterDefinition[];
  withCommon?: boolean;
  commonDateTime?: boolean;
};

export type QueryFiltersProps = Props;

export const QueryFilters: React.FC<Props> = ({
  filtersDefinitions: filtersDefinitionsProp,
  withCommon,
  commonDateTime,
}) => {
  const { filters, setFilters, resetFilter, resetFilters } =
    useQueryFilters<DateFilters>();

  const filtersDefinitions = useMemo(() => {
    const definitions = [];
    if (withCommon) {
      if (commonDateTime) {
        definitions.push(
          ...filtersUtils.getCommonFilters(
            filters,
            FilterDefinitionType.DateTimeRange,
          ),
        );
      } else {
        definitions.push(...filtersUtils.getCommonFilters(filters));
      }
    }
    return [...definitions, ...(filtersDefinitionsProp || [])];
  }, [commonDateTime, filters, filtersDefinitionsProp, withCommon]);

  const handleReset = useCallback(() => {
    const persistentFilters = pick(
      filters,
      map(
        filter(filtersDefinitions, (f) => f.removable === false && !f.hidden),
        'name',
      ),
    );
    if (isEmpty(persistentFilters)) {
      resetFilters();
    } else {
      setFilters(persistentFilters);
    }
  }, [filters, filtersDefinitions, resetFilters, setFilters]);

  if (isEmpty(filter(filtersDefinitions, (f) => !f.hidden))) {
    return null;
  }

  return (
    <div className="tw-flex tw-text-right tw-my-2">
      <div className="tw-flex-1 tw-text-left">
        <FiltersChips
          filters={filters}
          definitions={filtersDefinitions}
          onDelete={(name: string) => resetFilter(name)}
        />
      </div>
      <div className="tw-flex tw-items-center">
        <FiltersDropdown
          initialValues={filters}
          filters={filters}
          definitions={filtersDefinitions}
          onReset={handleReset}
          onSubmit={setFilters}
        />
      </div>
    </div>
  );
};
